import { WallboxChargingDto } from '../../api'
import { WallboxChargingModel } from '../../models'

const fromWallboxChargingDtoToModelTransformer = (dto: WallboxChargingDto): WallboxChargingModel => {
  return {
    sessionId: dto.sessionID,
    wallboxId: dto.wallboxID,
    chargingStatus: dto.status,
    counterReadingStart: dto.chargeCounterReadingStart,
    counterReadingStop: dto.chargeCounterReadingStop,
    energyAll: dto.energyAll,
    energyDischarged: dto.energyDischarged,
    startAt: dto.startAt,
    stopAt: dto.stopAt,
    slotPrice: dto.slotPrice ?? 0,
  }
}

export default fromWallboxChargingDtoToModelTransformer
